import { omit } from 'lodash';
import { BasicType } from '../constants';
import { RecursivePartial } from '../typings';
import React from 'react';
import { IColumn } from '../blocks';
import MjmlBlock, { MjmlBlockProps } from '../components/MjmlBlock';

export type ColumnProps = RecursivePartial<IColumn['data']> &
    RecursivePartial<IColumn['attributes']> & {
    children?: MjmlBlockProps<IColumn>['children'];
};

export function Column(props: ColumnProps) {
    return (
        <MjmlBlock
            attributes={omit(props, ['data', 'children', 'value'])}
            value={props.value}
            type={BasicType.COLUMN}
        >
            {props.children}
        </MjmlBlock>
    );
}
